import React, { useState, useEffect } from "react";
import CssTransition from "../../component/layout/css-transition";
import InputField from "../../component/input-field";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

function ApproveExtend({
  openExtendModal,
  setOpenExtendModal,
  reqTime,
  handleAccept,
  id,
  reason
}) {
  const [allowance, setAllowance] = useState();

  useEffect(() => {
    setAllowance(reqTime);
  }, [reqTime]);

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={openExtendModal}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={openExtendModal}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div className="bg-white overflow-auto max-w-2xl w-full max-h-full rounded shadow-lg flex flex-col">
          <div class="py-8 px-6 ">
            <h3 class="mb-8 text-xl font-medium text-gray-900 flex justify-center">
              Approve Extend Request
            </h3>
            <div>
              <label className="block text-sm font-medium mb-1 ">
                Reason By User
              </label>
              <textarea
                className="form-input w-[100%] disabled:border-slate-200 resize-none"
                value={reason}
                rows={4}
              />
              <InputField
                type="text"
                label="Requested Time"
                wrapperClass="my-3"
                value={moment(reqTime).format("DD MMM, YYYY HH:mm")}
                // defaultValue={reqTime}
                disabled
              />
              <div>
                <label
                  for="datepicker"
                  className="text-sm font-medium leading-6"
                >
                  Allowance
                </label>
                <Flatpickr
                  data-enable-time
                  options={{
                    enableTime: true,
                    altInput: true,
                    altFormat: "j M, Y H:i",
                    dateFormat: "Y-m-d H:i",
                    time_24hr: true,
                    minDate: "today",
                  }}
                  // defaultValue={moment(allowance).format("Y-MM-DD HH:mm")}
                  value={moment(allowance).format("Y-MM-DD HH:mm")}
                  // value={allowance}
                  onChange={(e) => {
                    console.log("allowance --", e);
                    setAllowance(e[0]);
                  }}
                  placeholder="Select Date"
                  className="w-full rounded-md border-2 border-gray-200 border-r-4 active:border-gray-200 focus:border-gray-200"
                />
              </div>
            </div>
            <div className="flex justify-end item center my-3 space-x-2">
              <button
                className="btn border-slate-300 hover:border-slate-300 text-slate-600"
                onClick={() => setOpenExtendModal(!openExtendModal)}
              >
                Cancel
              </button>
              <button
                className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white border-1"
                onClick={() => handleAccept(allowance, id)}
              >
                Approve
              </button>
            </div>
          </div>
        </div>
      </CssTransition>
    </>
  );
}

export default ApproveExtend;
